import React, { useEffect, useState } from "react";
import Breadcrumb from "./Breadcrumb";
import menu from "../../assets/images/icons/menu.svg";
// import bell from "../../assets/images/icons/bell.svg";
// import search from "../../assets/images/icons/search.svg";
import logo from "../../assets/images/logo-white.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";

const Header = props => {
	const toggleMenu = () => {
		const sidebar = document.getElementById("sidebar");
		sidebar.classList.toggle("sidebar-sm");
		const contentWrapper = document.getElementById("content-wrapper");
		contentWrapper.classList.toggle("wrapper-sm");
	};

	// const toggleResponsiveMenu = () => {
	// 	const sidebar = document.getElementById("sidebar");
	// 	sidebar.classList.toggle("sidebar-responsive");
	// 	const sidebarWrapper = document.getElementById("sm-wrapper");
	// 	sidebarWrapper.classList.toggle("sm-wrapper-toggle");
	// };

	// const toggleNotifications = () => {
	// 	const notifications = document.getElementById("notifications");
	// 	notifications.classList.toggle("notifications-toggle");
	// 	const notificationsWrapper = document.getElementById("not-sm-wrapper");
	// 	notificationsWrapper.classList.toggle("not-sm-wrapper-toggle");
	// };

	const [settings, setSettings] = useState([]);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/main`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSettings(response.data.data);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const logoSrc =
		settings.find(setting => setting.name === "appLogo")?.value || logo;

	return (
		<header>
			<div className="content-container">
				<div className="row ">
					<div className="col-6 d-block d-sm-none">
						<Link to="/">
							<img
								src={
									logoSrc !== ""
										? `${process.env.REACT_APP_MAIN_URL}${logoSrc}`
										: logo
								}
								alt="Logo"
								className="logo-sm"
								style={{
									filter: "brightness(0) invert(1)",
									width: "100px",
								}}
							/>
						</Link>
					</div>
					<div className="col-6 d-sm-block  ">
						<button className="menu-button" onClick={toggleMenu}>
							<img src={menu} alt="menu" />
						</button>
					</div>
					{/* <div className="col-md-8 col-7">
						<ul className="list-inline header-list">
							<li className="list-inline-item">
								<a href="/">
									<img src={search} alt="search" />
								</a>
							</li>
							<li className="list-inline-item">
								<button onClick={toggleNotifications}>
									<img src={bell} alt="notifications" />
								</button>
							</li>
							<li className="list-inline-item d-inline-block d-sm-none">
								<button onClick={toggleResponsiveMenu} style={{ margin: 0 }}>
									<img src={menu} alt="menu" />
								</button>
							</li>
						</ul>
					</div> */}
				</div>
			</div>
			<div className="header-border"></div>
			<div className="content-container">
				<div className="row">
					<div className="col-md-6 d-none d-sm-block">
						<h1>مرحبا بعودتك...</h1>
					</div>
					<div className="col-12 col-md-6">
						<Breadcrumb breadcrumbTitle={props.breadcrumbTitle} />
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
